<template>
  <nav class="intake-navigation mb-3">
    <button
      class="intake-navigation__item btn btn--sm"
      :class="{ 'is-active': activeTab === 'intake', 'has-errors': roomErrors.length }"
      type="button"
      @click="() => setActiveTab('intake')"
    >
      1. Inventariseren

      <span class="intake-navigation__icon">
        <Icon name="exclamation" />
      </span>
    </button>

    <button
      class="intake-navigation__item btn btn--sm"
      :class="{ 'is-active': activeTab === 'client', 'has-errors': clientErrors.length }"
      type="button"
      @click="() => setActiveTab('client')"
    >
      2. Gegevens

      <span class="intake-navigation__icon">
        <Icon name="exclamation" />
      </span>
    </button>

    <button
      class="intake-navigation__item btn btn--sm"
      :class="{ 'is-active': activeTab === 'addition', 'has-errors': additionErrors.length }"
      type="button"
      @click="() => setActiveTab('addition')"
    >
      3. Toelichting

      <span class="intake-navigation__icon">
        <Icon name="exclamation" />
      </span>
    </button>

    <button
      v-if="activeTab === 'addition'"
      class="intake-navigation__item btn btn--primary btn--sm"
      :class="{ 'has-errors': hasErrors }"
      type="button"
      @click="() => submit()"
      :disabled="isLoading"
    >
      4. {{ isLoading ? 'Moment a.u.b.' : 'Versturen' }}

      <span class="intake-navigation__icon">
        <Icon name="exclamation" />
      </span>
    </button>
  </nav>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Icon from '@/intake/components/Icon.vue';

export default {
  components: {
    Icon,
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'activeTab',
      'clientErrors',
      'roomErrors',
      'additionErrors',
    ]),

    hasErrors() {
      return (
        this.clientErrors && this.clientErrors.length
        || this.roomErrors && this.roomErrors.length
        || this.additionErrors && this.additionErrors.length
      );
    },
  },

  methods: {
    ...mapActions([
      'submit',
    ]),

    ...mapMutations([
      'setActiveTab',
    ]),
  },
};
</script>
